import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Products = lazy(() => import('../pages/products/page'));
const ProductDetail = lazy(() => import('../pages/product-detail/page'));
const Category = lazy(() => import('../pages/category/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Login = lazy(() => import('../pages/auth/login/page'));
const Register = lazy(() => import('../pages/auth/register/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const AdminReports = lazy(() => import('../pages/admin/reports/page'));
const SetupAdmin = lazy(() => import('../pages/setup-admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/urunler',
    element: <Products />
  },
  {
    path: '/urun/:id',
    element: <ProductDetail />
  },
  {
    path: '/kategori/:slug',
    element: <Category />
  },
  {
    path: '/profil',
    element: <Profile />
  },
  {
    path: '/giris',
    element: <Login />
  },
  {
    path: '/kayit',
    element: <Register />
  },
  {
    path: '/admin',
    element: <Admin />
  },
  {
    path: '/admin/raporlar',
    element: <AdminReports />
  },
  {
    path: '/admin-kurulum',
    element: <SetupAdmin />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
